import { docodeHexResponse } from "../../_common/common.utils";
import AverageMonthlyPerformanceReportTypes from "./averageMonthlyPerformanceReport.types";
const INITIAL_STATE: any = {
  averageMonthlyPerformanceReportFetchResponseArr: [],
  averageMonthlyPerformanceReportDatewiseResponseArr: [],
  averageMonthlyPerformanceReportFetchResponse: null,
  averageMonthlyPerformanceReportDateWiseResponse: null,
  averageMonthlyPerformanceReportExportResponse: null,
  averageMonthlyPerformanceReportExportResponseArr: [],
  exportAverageMonthlyPerformanceReportStatus: "",
};
const averageMonthlyPerformanceReportReducer = (
  state = INITIAL_STATE,
  action: any,
) => {
  switch (action.type) {
    case AverageMonthlyPerformanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_SUCCESS:
      return {
        ...state,
        averageMonthlyPerformanceReportFetchResponse: action.payload,
        averageMonthlyPerformanceReportFetchResponseArr: docodeHexResponse(
          action.payload,
          "AverageMonthlyPerformanceReportKey",
        ),
      };

    case AverageMonthlyPerformanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_FAILURE:
      return {
        ...state,
        averageMonthlyPerformanceReportFetchResponse: action.payload,
        averageMonthlyPerformanceReportFetchResponseArr: [],
      };

    case AverageMonthlyPerformanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_RESPONSE_CHANGED:
      return { ...state, averageMonthlyPerformanceReportFetchResponse: null };
    case AverageMonthlyPerformanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_SUCCESS:
      return {
        ...state,
        averageMonthlyPerformanceReportExportResponse: action.payload,
        averageMonthlyPerformanceReportExportResponseArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportAverageMonthlyPerformanceReportStatus: "Success",
      };

    case AverageMonthlyPerformanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_FAILURE:
      return {
        ...state,
        averageMonthlyPerformanceReportExportResponse: action.payload,
        averageMonthlyPerformanceReportExportResponseArr: [],
        exportAverageMonthlyPerformanceReportStatus: "Failure",
      };

    case AverageMonthlyPerformanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_CHANGED:
      return {
        ...state,
        averageMonthlyPerformanceReportExportResponse: null,
        exportAverageMonthlyPerformanceReportStatus: "",
      };

    default:
      return state;
  }
};
export default averageMonthlyPerformanceReportReducer;
